import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authorize: AuthService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            // 401 only: no session (or an expired one) is the one case a login can cure.
            // A 403 comes from an AUTHENTICATED session the server refused — e.g. the read-only
            // staff impersonation role on an exemption write. Sending that to the SSO page just
            // bounces the user to the Georgia Bar login with no explanation (CLE-OOS work order,
            // docs/checkcle/CLE-OOS-EXEMPTION-LOGIN-BOUNCE-WORKORDER.md). It is re-thrown below so
            // the caller can show the server's message.
            if (err.status === 401) {
                const redirect = this.authorize.attemptedUrl || (window.location.pathname + window.location.search);
                const authReturnUrl = '/auth-return?redirect=' + encodeURIComponent(redirect);
                window.location.href = environment.atsSsoUrl + '?returl=' + environment.clientAppUrl + encodeURIComponent(authReturnUrl);
            }

            // Re-throw the original HttpErrorResponse so downstream handlers can inspect
            // err.status / err.error (e.g. typed 409 conflict codes). Flattening it to a
            // string here silently broke every status-aware error handler in the app.
            console.error(err);
            return throwError(() => err);
        }))
    }
}
